import { Component } from '@angular/core';

@Component({
    selector: 'app-cylinder-graph-table-header',
    templateUrl: './cylinder-graph-table-header.component.html',
    styleUrl: './cylinder-graph-table-header.component.css',
    standalone: false,
})
export class CylinderGraphTableHeaderComponent {}
